// extracted by mini-css-extract-plugin
export default {"table-header":"PendingCertifications_table-header__MZFpK"};